import { FC, useEffect } from 'react';
import { useMap } from 'react-leaflet';
import { useMapZoomLimits } from '../../hooks/use-map-zoom-limits';

export const SyncZoomLimits: FC = () => {
  const map = useMap();
  const { minZoom, maxZoom } = useMapZoomLimits();

  useEffect(() => {
    if (map.getMinZoom() === minZoom && map.getMaxZoom() === maxZoom) return;
    // Order avoids a transient min > max state
    if (minZoom > map.getMaxZoom()) {
      map.setMaxZoom(maxZoom);
      map.setMinZoom(minZoom);
    } else {
      map.setMinZoom(minZoom);
      map.setMaxZoom(maxZoom);
    }
  }, [map, minZoom, maxZoom]);

  return null;
};
